export const aboutData = {
  subtitle: "关于 51 吃瓜",
  title: "全网吃瓜",
  titleHighlight: "一站式平台",
  description: "51吃瓜网成立于2020年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为用户提供最真实、最及时的网红爆料、明星八卦、直播风波等吃瓜内容。平台覆盖全网12,800+网红、3,600+明星的动态追踪，累计发布爆料超过86,500条，日均更新300+条。",
  stats: [
    { label: "覆盖网红数", value: "12,800+" },
    { label: "追踪明星数", value: "3,600+" },
    { label: "累计爆料量", value: "86,500+" },
    { label: "日更新量", value: "300+" },
  ],
  brandImage: "https://readdy.ai/api/search-image?query=Dramatic%20modern%20newsroom%20workspace%20with%20multiple%20monitors%20showing%20data%20dashboards%20in%20warm%20amber%20and%20dark%20moody%20lighting%2C%20cinematic%20editorial%20photography%2C%20high%20contrast%2C%20elegant%20minimal%20composition%2C%20professional%20atmosphere&width=800&height=600&seq=about-brand&orientation=landscape",
};

export const platformAdvantages = [
  {
    icon: "ri-radar-line",
    title: "全网追踪",
    desc: "7x24小时自动爬取全网热点，覆盖微博、抖音、快手、小红书等主流平台，第一时间发现新瓜。",
  },
  {
    icon: "ri-shield-check-line",
    title: "多方验证",
    desc: "每条爆料经过3个以上独立信源交叉核实，确保信息真实可靠，杜绝虚假造谣。",
  },
  {
    icon: "ri-eye-off-line",
    title: "隐私浏览",
    desc: "支持无痕浏览模式，吃瓜不留痕迹，保护用户隐私安全。",
  },
  {
    icon: "ri-flashlight-line",
    title: "实时更新",
    desc: "专业编辑团队全天候值守，事件进展实时同步，吃瓜永不错过。",
  },
  {
    icon: "ri-video-line",
    title: "视频存档",
    desc: "所有黑料视频均有完整存档，支持在线观看和离线下载，随时回看好瓜。",
  },
  {
    icon: "ri-notification-3-line",
    title: "精准推送",
    desc: "关注感兴趣的网红/明星，有新瓜第一时间推送通知，做朋友圈最早的吃瓜群众。",
  },
];

export const contactCta = {
  title: "商务合作与联系",
  subtitle: "51吃瓜网诚邀品牌方、内容创作者及媒体合作伙伴建立长期合作关系。我们拥有精准的用户群体和强大的内容分发能力。",
  buttonLabel: "立即联系商务合作",
  partners: [
    "https://readdy.ai/api/search-image?query=Clean%20minimal%20company%20logo%20placeholder%20on%20white%20background%2C%20modern%20corporate%20brand%20identity%20design%2C%20simple%20geometric%20shapes%2C%20warm%20neutral%20tones&width=200&height=60&seq=partner-1&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Clean%20minimal%20company%20logo%20placeholder%20on%20white%20background%2C%20modern%20corporate%20brand%20identity%20design%2C%20simple%20geometric%20shapes%2C%20warm%20neutral%20tones&width=200&height=60&seq=partner-2&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Clean%20minimal%20company%20logo%20placeholder%20on%20white%20background%2C%20modern%20corporate%20brand%20identity%20design%2C%20simple%20geometric%20shapes%2C%20warm%20neutral%20tones&width=200&height=60&seq=partner-3&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Clean%20minimal%20company%20logo%20placeholder%20on%20white%20background%2C%20modern%20corporate%20brand%20identity%20design%2C%20simple%20geometric%20shapes%2C%20warm%20neutral%20tones&width=200&height=60&seq=partner-4&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Clean%20minimal%20company%20logo%20placeholder%20on%20white%20background%2C%20modern%20corporate%20brand%20identity%20design%2C%20simple%20geometric%20shapes%2C%20warm%20neutral%20tones&width=200&height=60&seq=partner-5&orientation=landscape",
  ],
};

export const faqData = [
  {
    question: "51吃瓜网的信息来源可靠吗？",
    answer: "51吃瓜网所有爆料均经过专业团队的多方交叉验证。我们要求每条爆料至少有3个以上独立信源支持，并通过图片、视频、聊天记录等多种证据形式进行核实。同时，我们会在文章中明确标注信息来源和可信度评级。",
  },
  {
    question: "如何获取最新的吃瓜爆料推送？",
    answer: "您可以下载51吃瓜APP并开启推送通知，关注您感兴趣的网红或明星，有新瓜时我们会第一时间推送。同时，您也可以关注我们的官方微博和微信公众号，每日精选内容会同步发布。",
  },
  {
    question: "51吃瓜网的内容是否涉及侵权？",
    answer: "51吃瓜网严格遵守法律法规，所有内容均基于公开信息或当事人自行披露的信息。对于涉及个人隐私的内容，我们会进行必要的脱敏处理。若您认为某条内容侵犯了您的合法权益，可通过我们的举报通道提交申诉。",
  },
  {
    question: "如何在51吃瓜网上投稿爆料？",
    answer: "欢迎通过51吃瓜APP的「我要爆料」功能提交线索，或发送邮件至爆料邮箱。我们会保护爆料人隐私，所有投稿内容经核实后才会发布。对于重大独家爆料，我们还有专门的奖励机制。",
  },
  {
    question: "51吃瓜网支持哪些平台？",
    answer: "51吃瓜网目前支持Web端（PC和移动端浏览器）、iOS APP和Android APP三大平台。所有平台数据实时同步，您可以在任何设备上无缝切换，随时随地吃瓜。",
  },
  {
    question: "如何与51吃瓜网进行商务合作？",
    answer: "品牌方、MCN机构及媒体合作伙伴可通过本页底部的「商务合作」入口联系我们。我们提供品牌曝光、内容合作、数据报告等多种合作形式，期待与您建立长期合作关系。",
  },
];